import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { emptyModality, genderOptions, Modality } from "../../../../interfaces/modality";
import { getModalitySingle, updateModality } from "../../../../services/modality";
import { Speciality } from "../../../../interfaces/speciality";
import { getSpecialityOptions } from "../../../../services/speciality";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminModalityEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminModalityEdit(props: AdminModalityEditProps) {
    const [modality, setModality] = useState<Modality>(emptyModality);
    const [specialities, setSpecialities] = useState<Speciality[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            getSpecialityOptions(),
            getModalitySingle(props.id)
        ])
        .then((response: any) => {
            setSpecialities(response[0].data);
            setModality(response[1].data);
            setLoading(false);
        });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            speciality_id: event.target.speciality_id.value,
            name: event.target.name.value,
            description: event.target.description.value,
            gender: event.target.gender.value,
            distance: event.target.distance.value,
            boat: event.target.boat.value
        }
        updateModality(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }
    
    return (
        <Modal className="admin-modality-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_modality") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { loading && 
                    <LoadingSpinner />
                }
                { !loading && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Group className="mb-3" controlId="id">
                                <Form.Control type="hidden" name="id" required 
                                    defaultValue={ modality.id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="speciality_id">
                                <Form.Label aria-required="true">{ t("speciality") }</Form.Label>
                                <Form.Select aria-label={ t("speciality") } required defaultValue={ modality.speciality_id }>
                                    <option value="">{ t("select_speciality") }</option>
                                    { specialities.map((s: Speciality) => {
                                        return <option key={ 'speciality-' + s.id } value={ s.id }>{ s.name }</option>;
                                    })}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required
                                    defaultValue={ modality.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="gender">
                                <Form.Label aria-required="true">{ t("gender") }</Form.Label>
                                <Form.Select aria-label={ t("gender") } required defaultValue={ modality.gender }>
                                    <option value="">{ t("select_gender") }</option>
                                    { genderOptions.map((g: any) => {
                                        return <option key={ 'gender-' + g.value } value={ g.value }>{ t(g.label) }</option>
                                    })}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="distance">
                                <Form.Label aria-required="true">{ t("distance") }</Form.Label>
                                <Form.Control type="number" name="distance" defaultValue={ modality.distance }/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="boat">
                                <Form.Label aria-required="true">{ t("boat") }</Form.Label>
                                <Form.Control type="text" name="boat" required maxLength={ 50 } defaultValue={ modality.boat } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label>{ t("description") }</Form.Label>
                                <Form.Control name="description" as="textarea"
                                    defaultValue={ modality.description } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
